import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowRight } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';

const ProductCard = ({ product }) => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language?.startsWith('tr') ? 'tr' : 'en';

  // Helper to get localized text
  const getText = (field) => {
    if (typeof field === 'object' && field !== null && (field.en || field.tr)) {
      return field[lang] || field.en || '';
    }
    return field || '';
  };

  // Get language-specific image with size optimization
  const getImage = () => {
    let url;
    if (lang === 'tr') {
      if (product.cardImageTr) url = product.cardImageTr;
      else if (product.imagesTr && product.imagesTr.length > 0) url = product.imagesTr[0];
    }
    if (!url) url = product.cardImage || product.images[0];
    // Optimize Unsplash images: request smaller size for cards
    if (url && url.includes('unsplash.com')) {
      return url.replace(/&w=\d+/, '').replace(/\?w=\d+/, '?') + '&w=600&q=75';
    }
    return url;
  };

  return (
    <Link to={`/product/${product.id}`} className="block">
    <Card className="group overflow-hidden hover:shadow-xl transition-all duration-300 cursor-pointer">
      <div className="relative overflow-hidden aspect-[4/3]">
        <img
          src={getImage()}
          alt={getText(product.displayName) || product.name}
          loading="lazy"
          decoding="async"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      </div>
      <CardContent className="p-6 bg-[#cdcbbf]">
        <div className="mb-2">
          <span className="text-base font-medium text-gray-500 uppercase tracking-wide">
            {product.model || product.category}
          </span>
        </div>
        <h3 className="text-xl font-bold text-gray-900 mb-2 whitespace-pre-line">{getText(product.displayName) || product.name}</h3>
        <p className="text-gray-600 text-sm mb-4 line-clamp-2">
          {getText(product.shortDesc)}
        </p>
        <div className="group/btn p-0 h-auto">
          <span className="text-sm font-medium">{lang === 'tr' ? 'Detaylar' : 'View Details'}</span>
          <ArrowRight className="ml-2 h-4 w-4 inline group-hover:translate-x-1 transition-transform" />
        </div>
      </CardContent>
    </Card>
    </Link>
  );
};

export default ProductCard;
